@if (vm$ | async; as vm) {
  <div
    class="bolt-container-fluid help-padding"
    [formGroup]="form"
    [nwxExposeFormErrors]="form"
    formName="property"
    >
    @if (vm.showRoofYear) {
      <div
        class="bolt-row nwx-task-tile bolt-space-bottom-xl"
        >
        <nwx-roof-year
          formControlName="roofYear"
          [isNssUser]="isNssUser$ | async"
          [productType]="productType"
          (confirmClicked)="onRoofYearConfirmed()"
        ></nwx-roof-year>
        <div class="bolt-col"></div>
      </div>
    }
    @if (vm.showWaterProtectionDeviceQuestions) {
      <div
        class="bolt-row nwx-task-tile bolt-space-bottom-xl"
        >
        <div class="bolt-col">
          <nwx-leak-detection-form
            [coveredLocation]="coveredLocation || {}"
            [smartHome]="smartHomeEligibleDiscount$ | async"
            [isModal]="true"
            [product]="selectedPropertyProduct$ | async"
        (coveredLocationValueChange)="
          onWaterProtectoinDeviceRequirementCommunicatedChange($event)
        "
            (smartHomeValueChange)="onSmartHomeValueChange($event)"
          ></nwx-leak-detection-form>
        </div>
      </div>
    }
    @if (vm.showEarthquakeQuestions) {
      <div
        class="bolt-row nwx-task-tile bolt-space-bottom-xl"
        >
        <div class="bolt-col">
          <nwx-earthquake-details
            [earthquakeDetails]="coveredLocation?.earthquakeDetails || {}"
            [insideModal]="true"
            (formReady)="addChildForm('earthquakeDetails', $event)"
          ></nwx-earthquake-details>
        </div>
      </div>
    }
    @if (vm.showSinkholeQuestions) {
      <div
        class="bolt-row nwx-task-tile bolt-space-bottom-xl"
        >
        <div class="bolt-col">
          <nwx-sinkhole-details
            [sinkholeDetails]="coveredLocation?.sinkholeDetails || {}"
            [insideModal]="true"
            (formReady)="addChildForm('sinkholeDetails', $event)"
          ></nwx-sinkhole-details>
        </div>
      </div>
    }
    @if (vm.showProtectiveDevices) {
      <div
        class="bolt-row nwx-task-tile bolt-space-bottom-xl"
        >
        <div class="bolt-col">
          <nwx-protective-devices-list-form
            [protectiveDevices]="coveredLocation?.protectiveDevices || {}"
            [protectiveDeviceOptions]="protectiveDeviceOptions$ | async"
            [productType]="productType"
            [reconstructionCost]="coveredLocation?.reconstructionCost"
            formControlName="protectiveDevices"
          ></nwx-protective-devices-list-form>
        </div>
      </div>
    }
    @if (vm.showEligibilityQuestions) {
      <div class="bolt-row nwx-task-tile">
        <div class="bolt-col">
          <nwx-eligibility-inline-container
            (statusChange)="onEligibilityStatusChange($event)"
            [productType]="productType"
          ></nwx-eligibility-inline-container>
        </div>
      </div>
    }
  </div>
}
